export function sortshortc(a, b) {
  var aField = a.GetShortcutField();
  var bField = b.GetShortcutField();

  if (aField === bField) {
    var aName = a.GetShortcutName();
    var bName = b.GetShortcutName();
    if (aName === bName) {
      return 0;
    } else if (aName > bName) {
      return 1;
    }
    return -1;
  } else if (aField > bField) return 1;

  return -1;
}
